import { LOGGER_ENABLED } from '../constants'
import debounce from 'lodash/debounce'
import { LogActionWithDate } from './LogActionWithDate'
import { LogActionType } from 'api/logs/log-action-type'

class Logger {
  private schedule = debounce(() => this.send(), 1000, {
    leading: false,
  })
  private readonly enabled = LOGGER_ENABLED
  private scheduledLogs: Array<LogActionWithDate> = []

  constructor() {
    if (this.enabled) {
      window.addEventListener('beforeunload', () => this.send())
    }
  }

  log(action: LogActionType, payload?: any): void {
    if (this.enabled) {
      this.scheduledLogs.push({ type: action, payload, date: new Date() })
      this.schedule()
    }
  }

  private send() {
    if (this.scheduledLogs.length) {
      // createLog(this.scheduledLogs)

      this.scheduledLogs.length = 0
    }
  }
}

export const logger = new Logger()
